import { render, staticRenderFns } from "./poolCategory.vue?vue&type=template&id=49f4b25a&scoped=true"
import script from "./poolCategory.vue?vue&type=script&lang=ts"
export * from "./poolCategory.vue?vue&type=script&lang=ts"
import style0 from "./poolCategory.vue?vue&type=style&index=0&id=49f4b25a&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f4b25a",
  null
  
)

export default component.exports